import { useLocation, useParams } from "react-router-dom"
import { useRoute } from "@hydrologiq/shared/providers/helpers/useRoute"
import { useAsset } from "../../hooks/useAsset"
import { useRenameAsset } from "../../hooks/useRenameAsset"
import { routing } from "./routing"
import { pages } from "./pages"
import Selection, { SelectionItem, SubNavItem } from "@hydrologiq/shared/selection/Selection"
import { useGetCopyHomeRoute } from "@hydrologiq/shared/providers/helpers/useCopy"
import { useGetFeature } from "@hydrologiq/shared/providers/helpers/useFeature"

function AssetsSelection({ children }: { children?: React.ReactNode }) {
  const { assetId } = useParams()
  const route = useRoute()
  const location = useLocation().pathname
  const assetForecastFeatureEnabled = useGetFeature("asset_forecast")
  const servicingEnabled = useGetFeature("servicing")
  const hideReports = useGetFeature("hide_reports_asset")

  const { asset } = useAsset(assetId)
  const { asset: parentAsset } = useAsset(asset?.parentId ?? undefined)
  const { renameAsset, renaming } = useRenameAsset(asset)

  const sectionPages = pages(location, assetId !== undefined, servicingEnabled, assetForecastFeatureEnabled, hideReports)

  // Create sub-navigation items from sectionPages
  const subNavItems: SubNavItem[] = Object.entries(sectionPages.pages).map(([key, value]) => ({
    name: value,
    href: routing(route, location, assetId, false, key),
    disabled: false,
  }))

  // Create parents for breadcrumb navigation
  const parents: SelectionItem[] = []
  if (asset?.parentId) {
    const parentHref = `${route}/${asset.parentId}`.replace(/\/+/g, "/")
    parents.push({
      id: asset.parentId,
      name: parentAsset?.name || "Parent Asset",
      href: parentHref,
    })
  }
  const { name, path } = useGetCopyHomeRoute()

  return (
    <Selection
      sectionHeading={name}
      sectionBase={path}
      item={asset ? { id: asset.id, name: asset.name, onRename: renameAsset, renaming } : undefined}
      parents={parents}
      subNavItems={subNavItems}
      subNavHome={sectionPages.defaultPage}
      branding={asset?.brand_url ?? undefined}
      badge={asset?.parentId ? "Module" : undefined}
    >
      {children}
    </Selection>
  )
}

export default AssetsSelection
